import React from 'react'
import { View } from 'react-native'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import LocalizationContext from '../../context/LocalizationContext'
import Loading from '../../components/basic/Loading'
import CreditList from '../../components/CreditList'
import _ from 'lodash'
import EmptyView from '../../components/basic/EmptyView'

function CreditListScreen(props) {
    const { t } = React.useContext(LocalizationContext)
    const { creditStore, navigation, route } = props
    const [isLoading, setIsLoading] = React.useState(true)


    React.useEffect(() => {
        const componentDidMount = async () => {
            try {
                await creditStore.listCredit(0)
            }
            catch (e) {
                console.log(e)
            }
            setIsLoading(false)
        }

        componentDidMount()
    }, [navigation])




    const handleOnEndReached = async () => {
        if (toJS(creditStore.creditRecords).length < toJS(creditStore.creditRecordCount)) {
            try {
                await creditStore.listMoreUserCredit(toJS(creditStore.creditRecords).length)
            }
            catch (e) {
                console.log(e)
            }
        }
    }

    if (isLoading) {
        return <Loading />
    }

    if (!toJS(creditStore.creditRecords).length) {
        return <EmptyView t={t} />
    }

    return (
        <CreditList
            t={t}
            records={toJS(creditStore.creditRecords)}
            onEndReached={() => handleOnEndReached()}
        />
    )
}

export default inject('creditStore')(observer(CreditListScreen))